<template>
  <DialogContainer v-model="dialogObj" v-if="dialogObj.show">
    <template v-slot:dialogSlot>
      <div class="business-body custom-form">
        <el-form ref="form" :model="form" :rules="rules" label-position="top">
          <el-form-item label="角色名称" prop="roleName">
            <el-input
              v-model="form.roleName"
              clearable
              autocomplete="off"
              maxlength="20"
              placeholder="请输入"
            />
          </el-form-item>
          <el-form-item label="角色描述" prop="remark">
            <el-input
              v-model="form.remark"
              clearable
              autocomplete="off"
              type="textarea"
              rows="5"
              maxlength="300"
              placeholder="请输入"
            />
          </el-form-item>
        </el-form>
      </div>
    </template>
  </DialogContainer>
</template>

<script>
import DialogContainer from "@/components/Dialog.vue";
import { addInfo, detailInfo, editInfo } from "./api";

export default {
  name: "AddOrEdit",
  components: {
    DialogContainer,
  },
  data() {
    return {
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "30%",
        show: false,
        title: "添加/编辑角色",
        closeOnClickModal: false,
        confirmFn: this.submitForm,
        beforeClose: (v) => {
          this.form = this.$options.data().form;
          if (this.$refs.form) this.$refs.form.resetFields();
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      form: {
        menuIds: [],
        remark: "",
        roleName: "",
      },
      rules: {
        roleName: [{ required: true, message: "角色名称不能为空" }],
      },
    };
  },
  mounted() {},
  methods: {
    init(row) {
      if (!!row) {
        // this.form = Object.assign({}, row);
        this.getDetail(row.roleId)
      }
      this.dialogObj.show = true;
    },
    getDetail(roleId) {
      detailInfo(roleId).then((res) => {
        if (res.code === 200) {
          this.form = res.data;
        }
      })
    },
    // 提交数据
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.dialogObj.btnLoading = true;
          let methodName = "";
          if (this.form.roleId) {
            methodName = editInfo;
          } else {
            methodName = addInfo;
          }
          const par = {
            roleId: this.form.roleId,
            remark: this.form.remark,
            roleName: this.form.roleName,
          };
          methodName(par)
            .then((res) => {
              this.dialogObj.btnLoading = false;
              if (res.code === 200) {
                this.$message.success(
                  this.form.roleId ? "编辑成功" : "保存成功"
                );
                this.$parent.getRoleData();
                this.dialogObj.beforeClose();
              }
            })
            .catch((e) => {
              this.dialogObj.btnLoading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.business-body {
  box-sizing: border-box;
  .code-image {
    width: 1.2rem;
    height: 100%;
    cursor: pointer;
    position: relative;
    right: -0.16rem;
    font-weight: 400;
    font-size: 0.14rem;
    color: #1966ff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .code-image-disable {
    color: #999999;
  }
}
</style>
